import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {AlertsFilter} from '../models/alerts-filter.model';
import {FilterService} from '../../shared/models/filter-service.model';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AlertFilterService implements FilterService {

	private filterSubject = new Subject<AlertsFilter>();
	private filterObservable$ = this.filterSubject.asObservable();

	private currentFilter: AlertsFilter;
	private lastFilter: AlertsFilter;

	getFilterObservable(): Observable<AlertsFilter> {
		return this.filterObservable$;
	}

	updateFilter(filter: AlertsFilter) {
		this.currentFilter = filter;
		this.filterSubject.next(filter);
		if (this.currentFilter !== null) {
			this.lastFilter = this.currentFilter;
		}
	}

	getCurrentFilter(): AlertsFilter {
		return this.currentFilter;
	}

	getEmptyFilter(): AlertsFilter {
		return this.currentFilter = new AlertsFilter();
	}

	reloadLastFilter() {
		this.updateFilter(this.lastFilter);
	}
}
